<template>
    <div class="user__del">
        <loading :active.sync="isLoading"
                 :can-cancel="true"
                 :is-full-page="true">
        </loading>
        <div v-if="localAddress.length > 0">
        <div v-for="(address, index) in localAddress" class="user__del-item">
            <div class="card">
                <div class="card-body">
                    <div class="row-9 mb20">
                        <div class="card-title">{{ address.name }}</div>
                        <div class="card-text">
                            <div class="user__del-item-address">
                                {{ address.city_name}}, ул. {{ address.street}} дом {{ address.house}} кв. {{ address.flat}} {{ address.building}}
                            </div>
                            <div class="user__del-item-comment">{{ address.comment }}</div>
                        </div>
                    </div>
                    <div class="row-3">
                        <a v-if="editRow===0" @click.prevent="(editRow===0)?editRow=address.id:editRow=0" class="user__del-item-btn badge badge-primary" href="#">Редактировать</a>
                        <a v-if="editRow===0" @click.prevent="showDelete=address.id" class="user__del-item-btn badge badge-danger" href="#"><span>Удалить</span></a>
                        <a class="btn btn--red btn--small" v-if="showDelete===address.id" href="#" @click.prevent="delAddress(address.id)">Да</a>
                        <a class="btn btn--blue btn--small" v-if="showDelete===address.id" href="#" @click.prevent="showDelete=0">Нет</a>
                    </div>


                    <div class="edit-form col-6" v-if="editRow==address.id">
                        <div class="text-right"><a @click.prevent="editRow=0" title="закрыть форму редактирования" href="#">выйти из редактирования<i class="fa fa-check fa-2x fa-fw"></i></a></div>

                        <label class="order__input-label" for="DelivForm_name">Название</label>
                        <div class="order__input-wr">
                            <input v-model="localAddress[index].name" v-on:blur="updateData(index)" class="order__input" id="DelivForm_name" name="DelivForm[name]" type="text"/>
                        </div>
                        <label class="order__input-label" for="DelivForm_street">Улица</label>
                        <div class="order__input-wr">
                            <input v-model="localAddress[index].street" v-on:blur="updateData(index)" class="order__input" id="DelivForm_street" name="DelivForm[street]" type="text"/>
                            <svg class="order__required" width="15" height="15">
                                <use xlink:href="#icon-asterisk"></use>
                            </svg>
                        </div>
                        <label class="order__input-label" for="DelivForm_house">Дом</label>
                        <div class="order__input-wr">
                            <input v-model="localAddress[index].house" v-on:blur="updateData(index)" class="order__input" id="DelivForm_house" name="DelivForm[house]" type="text"/>
                            <svg class="order__required" width="15" height="15">
                                <use xlink:href="#icon-asterisk"></use>
                            </svg>
                        </div>
                        <label class="order__input-label" for="DelivForm_building">Строение</label>
                        <div class="order__input-wr">
                            <input v-model="localAddress[index].building" v-on:blur="updateData(index)" class="order__input" id="DelivForm_building" name="DelivForm[building]" type="text"/>
                        </div>
                        <label class="order__input-label" for="DelivForm_flat">Квартира/офис</label>
                        <div class="order__input-wr">
                            <input v-model="localAddress[index].flat" v-on:blur="updateData(index)" class="order__input" id="DelivForm_flat" name="DelivForm[flat]" type="text"/>
                        </div>
                        <label class="order__input-label" for="DelivForm_comment">Комментарий</label>
                        <div class="order__input-wr">
                            <input v-model="localAddress[index].comment" v-on:blur="updateData(index)" class="order__input" id="DelivForm_comment" name="DelivForm[comment]" type="text"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div class="p-3" v-else>
            нет адресов доставки
        </div>
    </div>
</template>

<script>
    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "delivery-address",
        components: {
            Loading
        },
        data () {
            return {
                localAddress: {},
                showDelete: false,
                editRow: 0,
            }
        },
        computed: {
            isLoading() {
                return this.$store.getters.loading;
            }
        },
        methods: {
            getAddress(last_edit_row=false) {
                this.$store.commit('setLoading', true);
                let params = new URLSearchParams();
                params.append('param', 'deliv_address');

                axios.get('/rest/profile', {params})
                    .then((response) => {

                        this.localAddress = JSON.parse(response.data);

                        if(last_edit_row) {
                            this.editRow = this.localAddress[this.localAddress.length-1].id
                        }
                        this.$store.commit('setLoading', false);
                    }).catch(error => console.log(error))

            },
            delAddress (id) {
                let params = new URLSearchParams();
                params.append('action', 'delete_address');
                params.append('id', id);
                axios.delete('/rest/profile', {data:params})
                    .then((response) => {
                        this.getAddress();
                        this.showDelete = false;
                    }).catch(error => console.log(error))
            },
            updateData (index) {
                let params = new URLSearchParams();
                params.append('action', 'update_address');
                params.append('set_default', 0);
                params.append('id', this.localAddress[index].id);
                params.append('value', JSON.stringify(this.localAddress[index]));
                axios.put('/rest/profile', params)
                    .then((response) => {
                        this.getAddress();
                    }).catch(error => console.log(error))
            },
            newAddress () {
                let params = new URLSearchParams();
                params.append('action', 'add_address');
                params.append('value', JSON.stringify({}));

                axios.post('/rest/user/update-address', params)
                    .then((response) => {
                        this.getAddress(true);

                    }).catch(error => console.log(error))
            },
        },
        created () {
            this.getAddress()
        }
    }
</script>

<style scoped>

</style>
